import {
  WorkspaceDialogService,
  type DialogComponentProps,
  type GLOBAL_DIALOG_SCHEMA,
} from '@affine/core/modules/dialogs';
import { useEffect, useMemo, useState } from 'react';
import * as styles from './index.css';
import { useI18n } from '@affine/i18n';
import IconFont from '@ys/repo-ui/base/IconFont';
import { useService } from '@toeverything/infra';
import { GlobalContextService } from '@affine/core/modules/global-context';
import { useNavigateHelper } from '@affine/core/components/hooks/use-navigate-helper';

export const UpgradePlanDialog = ({
  close,
  localStorageKey,
}: DialogComponentProps<GLOBAL_DIALOG_SCHEMA['upgrade-plan']>) => {
  const t = useI18n();
  const [isShowUpgradePlan, setIsShowUpgradePlan] = useState(true);
  const globalContextService = useService(GlobalContextService);
  const currentWorkspaceId =
    globalContextService.globalContext.workspaceId.get();
  // 使用路由导航跳转到设置页面
  const { jumpToWorkspaceSettings } = useNavigateHelper();
  const onClose = () => {
    setIsShowUpgradePlan(false);
    close();
    // if (localStorageKey) {
    //   localStorage.setItem(localStorageKey, 'true');
    // }
    // close();
  };
  const onClickReject = () => {
    setIsShowUpgradePlan(false);
    close();
    // if (localStorageKey) {
    //   localStorage.setItem(localStorageKey, 'true');
    // }
    // close();
  };
  const onClickUpgrade = () => {
    close();

    if (currentWorkspaceId) {
      jumpToWorkspaceSettings(currentWorkspaceId, 'plans');
    }
  };
  useEffect(() => {
    if (localStorageKey) {
      localStorage.setItem(localStorageKey, 'true');
    }
  }, [localStorageKey]);

  return isShowUpgradePlan ? (
    <div className={styles.upgrade_wrapper}>
      <div className={`${styles.upgrade_content}`}>
        <div className={`${styles.upgrade_content_close}`}>
          <IconFont
            name="close-hoap7ooa"
            className={styles.upgrade_content_close_icon}
            onClick={onClose}
            size={24}
          />
        </div>
        <img
          className={styles.upgrade_content_image}
          src="https://wy-static.wenxiaobai.com/wenxiaobai-web/web-image/muset/upgradeModalIamge.png"
          alt=""
        />
        <div className={styles.upgrade_content_title}>
          {t['com.affine.user.free.upgrade.modal.title']()}
        </div>
        <div className={styles.upgrade_content_subtitle}>
          {t['com.affine.user.free.upgrade.modal.subtitle']()}
        </div>
        <div className={styles.upgrade_content_description}>
          {t['com.affine.user.free.upgrade.modal.description-1']()}
          <br />
          {t['com.affine.user.free.upgrade.modal.description-2']()}
        </div>
        <div className={styles.upgrade_content_button_wrapper}>
          <div
            className={styles.upgrade_content_button_return}
            onClick={onClickReject}
          >
            {t['com.affine.user.free.upgrade.modal.button-reject']()}
          </div>

          <div
            className={styles.upgrade_content_button_continue}
            onClick={onClickUpgrade}
          >
            {t['com.affine.user.free.upgrade.modal.button-upgrade']()}
          </div>
        </div>
      </div>
    </div>
  ) : null;
};
